import React from "react";

interface PoweredByModelsProps {}

const PoweredByModels: React.FC<PoweredByModelsProps> = () => (
  <>
    <h3 className="mt-4 text-sm opacity-80 font-inter">Models Powered by</h3>
    <div className="flex items-center justify-center gap-6 mt-2">
      <img
        src="/ratl/ratl-model-logos.png"
        alt="Models Powered by"
        className="md:w-1/2 w-3/4 object-contain"
      />
    </div>
  </>
);

export default PoweredByModels;
